import React from 'react'
import { Page } from '~/components'
import google from '../../assets/images/google_play_br.png'
import apple from '../../assets/images/app_store_br.png'

export default function OnlyOnApp({
    pageTitle = 'Marcar Consulta',
    title = 'AGENDAMENTOS? BAIXE O APP AGORA!',
}) {
    return (
        <Page title={pageTitle} card hideBreadcrumb>
            <h3 style={{ textAlign: 'center' }}>{title}</h3>
            <div className="flex items-center justify-center">
                <a
                    href="https://play.google.com/store/apps/details?id=com.mrfsolution.camimapp"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        style={{ width: 200 }}
                        src={google}
                        alt="Google Play"
                    />
                </a>
                <a
                    href="https://apps.apple.com/br/app/camim-app/id1019335872"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img style={{ width: 200 }} src={apple} alt="App Store" />
                </a>
            </div>
        </Page>
    )
}
